module.exports = __webpack_public_path__ + "images/4662d4f.png";